/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {DraggableItems} from './DraggableListItem';

/**
 * The utility function to help us with reordering the list result.
 * 
 * ```typescript
 * 
 *  import {reorder} from './DragableListUtils';
 * 
 *  reorder([item_1, item2], 1, 2);
 * 
 * ```
 */
export const reorder = (
  list: DraggableItems,
  startIndex: number,
  endIndex: number
): DraggableItems => {
  if (list) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  }
  return [];
};
